<h1 mat-dialog-title>{{ 'quest.dialogs.conflicting.title' | translate }}</h1>
<div mat-dialog-content>
    <span [innerHTML]="'quest.dialogs.conflicting.message' | translate"></span>
    <ul>
        <li *ngFor="let item of items">
            <span
                [innerHTML]="item.conflictingText + (item.conflictingUnit ? ' (' + item.conflictingUnit + ')' : '')"
            ></span>
            = <span [innerHTML]="item.conflictingValue"></span>
        </li>
    </ul>
    <span [innerHTML]="'quest.dialogs.conflicting.question' | translate"></span>
</div>
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false">{{ 'quest.dialogs.cancel' | translate }}</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>
        {{ 'quest.dialogs.continue' | translate }}
    </button>
</div>
